import React from 'react'
import Button from '@mui/material/Button';
import './footer.styles.scss'
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className='footer'>
            <div className='footer-content'>
                <div>
                    <label>{t("footer.ourproducts")}</label>
                    <Button aria-label={t("footer.ecommerce")} variant="text" onClick={() => navigate('/smartbip/ecommerce')}>{t("footer.ecommerce")}</Button>
                    <Button aria-label={t("footer.selfscannig")} variant="text" onClick={() => navigate('/smartbip/selfscanning')}>{t("footer.selfscanning")}</Button>
                    <Button aria-label={t("footer.inventory")} variant="text" onClick={() => navigate('/smartbip/inventory')}>{t("footer.inventory")}</Button>
                    <Button aria-label={t("footer.fidelity")} variant="text" onClick={() => navigate('/smartbip/fidelity')}>{t("footer.fidelity")}</Button>
                </div>
                <div>
                    <label aria-label={t("footer.legalsite")}>{t("footer.legalsite")}</label>
                    <p aria-label="RetAPPs Srl Via Amilcare Ponchielli, 51 24125 Bergamo">
                        RetAPPs Srl <br />
                        Via Amilcare Ponchielli, 51 <br />
                        24125 Bergamo<br />
                    </p>
                    <hr />
                    <p aria-label="PEC: retapps@pec.it REA: BG-472772">
                        PEC: retapps@pec.it<br />
                        REA: BG-472772<br />
                    </p>
                </div>
                <div>
                    <label aria-label={t("footer.operativesite")}>{t("footer.operativesite")}</label>
                    <p aria-label="RetAPPs Srl Via Melchiorre Gioia, 41 20124 Milano">
                        RetAPPs Srl <br />
                        Via Melchiorre Gioia, 41 <br />
                        20124 Milano<br />
                    </p>
                    <hr />
                    <p aria-label="C.F. e P.IVA: 03388720983 Cap. Soc.: 67.059,00 euro i.v.">
                        C.F. e P.IVA: 03388720983<br />
                        Cap. Soc.: 67.059,00 euro i.v.<br />
                    </p>
                    <Button aria-label={t("footer.find")} variant="text" className='link' onClick={() => window.open("https://maps.app.goo.gl/7DjKmeZQ5fJ5se3N7", "_blank")}>{t("footer.find")}</Button>
                </div>
            </div>
            <div className='footer-privacy'>
                <Button aria-label="Privacy Policy" variant="text" className='link' onClick={() => navigate('/policy')}>Privacy Policy</Button>
                <Button aria-label="Cookies" variant="text" className='link' onClick={() => navigate('/cookies')}>Cookies</Button>
                <label aria-label={t("footer.copyright")}>{t("footer.copyright")}</label>
            </div>
        </div>
    )
}

export default Footer